var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scontent"},[_c('div',{staticStyle:{"height":"0","max-height":"0"}},[(!_vm.routeName.includes(_vm.$route.name))?_c('menu-clientes',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"menuClientes"}):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }